/**
 * Typen der Seite „Versammlungsstätte (VDE 0100-718)" (EK-Folgepaket, 17.10.2026). Die Felder
 * entsprechen der JSON-Route `GET …/elektro/versammlungsstaette` (Versammlungsstaettenlauf).
 */

export const PDF_HINWEIS =
  'Der PDF-Abruf legt nur bei geändertem Stand eine neue Berichtsfassung mit neuer Dokumentnummer an; '
  + 'sonst liefert er die abgelegte Fassung (F11).';

export const BEREICH_HINWEIS =
  'Das Raumbuch kennzeichnet weder Bereiche für Besucher noch Rettungswege. Die Zuordnung läuft über Muster '
  + '(Annahme, Fachfrage ELT-38) — die Liste je Bereich mit Grenzfällen und Ausschlüssen bitte prüfen.';

export interface VstKennzahlen {
  raeume: number; besucherraeume: number; rettungswegraeume: number; grenzfaelle: number; ausgeschlossen: number;
  steckdosenkreise: number; steckdosenOk: number; steckdosenOffen: number; steckdosenWarnung: number;
  besucherraeumeOk: number; besucherraeumeWarnung: number; besucherraeumeOffen: number;
  rettungswegKreise: number; rettungswegOk: number; rettungswegWarnung: number; rettungswegOffen: number;
  kabelbemessungGelaufen: boolean; befunde: number; warnungen: number; aufAnnahmen: boolean;
}

export interface VstMusterzeile {
  bereich: string; status: string; name: string | null; nutzung: string | null; muster: string;
  ausschluss: string | null; raeume: number;
}

export interface VstKreis {
  regel: string; verteiler: string; kreis: string; bezeichnung: string | null; wert: string; status: string;
  befunde: string[];
}

export interface VstRaum {
  raumnummer: string; name: string | null; nutzung: string | null; geschoss: string | null; kreise: number;
  kennzeichen: string[]; status: string; befunde: string[];
}

export interface VstVorgabe {
  feld: string; verwendung: string | null; wert: string; einheit: string; bestaetigt: boolean; herkunft: string;
  normbezug: string; rueckfall: boolean;
}

export interface VersammlungsstaetteStand {
  kennzahlen: VstKennzahlen;
  bereiche: VstMusterzeile[];
  steckdosen: VstKreis[];
  beleuchtung: VstRaum[];
  rettungswege: VstKreis[];
  vorgaben: VstVorgabe[];
  befunde: string[];
  stand: string | null;
}
